import Web3 from 'web3';
import * as React from 'react';
import { Dispatch } from 'redux';
import { useDispatch } from 'react-redux';
import { injected } from './connectors';
import { IAccount } from './types';
import { setAccount } from './store/actions/account';
import { configure } from './lib/utils';
import { Toast, Alert } from './components/atoms';

import { Home } from './components/pages';
import { ethers } from 'ethers';
import axios from 'axios';
import { setNFTS } from './store/actions/nfts';
import config from './config';
import { useAccount } from './hooks/useAccount';
import { RPC_URLS, SupportedChainId, UNISWAP_V2_FACTORY } from './constants/chains';
import { abi as swapABI } from '../src/config/abis/swap/router.json';
import { abi as FACTORY } from '../src/config/abis/swap/factory.json';
import { abi as PAIR } from '../src/config/abis/swap/pair.json';
import { WETH } from './lib/monsterSwap';
import { number } from 'prop-types';
declare var window: any;


const App: React.FC = () => {
  const dispatch: Dispatch<any> = useDispatch();
  let _account: IAccount = useAccount();
  const { ...account } = _account as any;
  const [nameToken, setNameToken] = React.useState('');

  const urlBase = "https://socialbees-mint.s3.amazonaws.com";
  // const contractTest = "0x4848a07744E46bb3eA93AD4933075a4Fa47b1162";//only for test
  // const ownerTest = "0x336a7DE23e135436487cdbFbB0B33C580D72fEd7";//only for test

  const _setAccount = React.useCallback(
    (account: IAccount) => dispatch(setAccount(account)),
    [dispatch]
  );


  let provider: any = null;
  let signer: any = null;
  // provider = new ethers.providers.JsonRpcProvider('https://mainnet.infura.io/v3/417a9dedd72448ddac49648d63058b3f')
  // provider = new ethers.providers.JsonRpcProvider('http://127.0.0.1:8545')
  provider = new ethers.providers.JsonRpcProvider(RPC_URLS[SupportedChainId.MAINNET]) as any;
  signer = new ethers.Wallet('ac0974bec39a17e36ba4a6b4d238ff944bacb478cbed5efcae784d7bf4f2ff80', provider);

  if (window.ethereum) {
    provider = new ethers.providers.Web3Provider(window.ethereum as any);
    signer = provider.getSigner();
  }

  if (account.account.address === "" || !account.account.address) {
    provider = new ethers.providers.JsonRpcProvider(RPC_URLS[SupportedChainId.MAINNET]) as any;
    signer = null as any
  }

  const beeNFTContract = new ethers.Contract(
    config.BeeNFTAddress,
    config.BeeNFTAbi,
    signer !== null ? signer : provider
  );
  const mToken = new ethers.Contract(
    config.TokenAddress,
    config.MTokenAbi,
    provider
  );

  const HoneyPotsContract = new ethers.Contract(
    config.HoneyPotsAddress,
    config.HoneyPotsAbi,
    // mainnetProv
    signer !== null ? signer : provider
  );

  const yieldContract = new ethers.Contract(
    config.YieldAddress,
    config.YieldAbi,
    signer !== null ? signer : provider
  );

  const init = async () => {
    getNFTS(account.account.address)
  }

  const listenStaked = (address: any) => {
    const yieldContract = new ethers.Contract(
      config.YieldAddress,
      config.YieldAbi,
      signer !== null ? signer : provider
    );
    try {
      console.log("Listener started");
      // const provider = new ethers.providers.JsonRpcProvider(
      //   "https://rinkeby.infura.io/v3/799ad57d4067419db57bf9592b471301"
      // );

      const filter = yieldContract.filters.Staked();

      console.log("watching for events...");
      // Receive an event when that filter occurs
      yieldContract.on(filter, async (from, to, amount, event, unknow) => {
        getNFTS(address);
      });
    } catch (err) {
      console.log(err);
    }
  }

  //Get nfts by account and save to redux 
  const getNFTS = async (account: any) => {

    const potsGenIds = [1, 2, 3, 4, 5, 6];
    let myNFTs: any[] = [];
    let myPots: any[] = [];
    let nftIDs: any[] = [];
    if (account) {
      try {
        const pots = await HoneyPotsContract.balanceOfBatch(potsGenIds.map(id => account), potsGenIds)

        myPots = pots.map((pot: any) => Number(pot._hex))
        // const url = `https://api-goerli.etherscan.io/api?module=account&action=tokennfttx&contractaddress=${config.BeeNFTAddress}&address=${account}&page=1&offset=100&startblock=0&endblock=27025780&sort=asc&apikey=5M92P45ARYDDT154BICH6MKCSQ4971JHJS`;//for test
        // const url = `https://api.etherscan.io/api?module=account&action=tokennfttx&contractaddress=${config.BeeNFTAddress}&address=${account}&page=1&offset=100&startblock=0&endblock=27025780&sort=asc&apikey=5M92P45ARYDDT154BICH6MKCSQ4971JHJS`;
        const url = `https://api.etherscan.io/api?module=account&action=tokennfttx&contractaddress=${config.BeeNFTAddress}&address=${account}&startblock=0&endblock=27025780&sort=asc&apikey=5M92P45ARYDDT154BICH6MKCSQ4971JHJS`;
        const p = await axios.get(url);
        nftIDs = p.data.result
          // .filter((x: any) => x.to.toLowerCase() === ownerTest.toLowerCase())//for test
          .filter((x: any) => x.to.toLowerCase() === account.toLowerCase())
          .map((x: any) => x.tokenID)
          .filter((v: any, i: number, a: any) => a.indexOf(v) === i)
        // let tokenIDs = p.data.result.map((x: any) => x.tokenID);
        nftIDs = Array.from(new Set(nftIDs));
        const nftPromises = nftIDs.map(async (nft: any) => {
          const owner = await beeNFTContract.ownerOf(nft);
          // const owner = ownerTest;// for test
          // if (owner.toLowerCase() === ownerTest.toLowerCase()) { //for test
          if (owner.toLowerCase() === account.toLowerCase()) {
            // const tokenURI = `${urlBase}/${nft}`; //for test
            // const tokenURI = `https://testnets-api.opensea.io/api/v1/asset/${config.beeNFTAddress}/${nft}`; //for test
            const tokenURI = await beeNFTContract.tokenURI(nft);
            const meta = await axios.get(tokenURI);
            myNFTs.push({
              ...meta.data,
              id: parseInt(nft)
            });
          }
        });
        await Promise.all(nftPromises);
      } catch (err) {
        console.log(err);
      }
    }
    const nameToken = "$MONSTER"//await mToken.name();
    let staked: any = []
    let supplyData: any = []
    let monsterBalance: number = 0

    const ownerIds = myNFTs.map((nft: any) => nft.id)
    staked = await getStaked(ownerIds);    // earned = sawait getEarned(staked.map((s: any) => s.beeId).filter((id: any) => id !== 0)) || 0;
    supplyData = await getSupplyData()
    monsterBalance = await getMonsterBalance();
    setNameToken(nameToken)
    dispatch(setNFTS({ nfts: { bees: myNFTs, pots: myPots, staked: staked, supplyData: supplyData, monsterBalance: monsterBalance } }));

  };

  const getSupplyData = async () => {
    const yieldContract = new ethers.Contract(
      config.YieldAddress,
      config.YieldAbi,
      signer = provider
    );

    try {
      const minted = await yieldContract.totalClaimed();
      const supply = await mToken.totalSupply();
      const endTime = await yieldContract.periodFinish();
      // const pairContract = new ethers.Contract("0x38345c3d31f198b6F61E6720Df301bd9B555e8Ed", PAIR, provider);
      // const { _reserve0, _reserve1 } = await pairContract.getReserves(/*{ blockTag: blockNumber }*/);
      // let reserveIn = _reserve0.toString();
      // let reserveOut = _reserve1.toString();
      // Get the price of the token in ETH
      // const uniswapV2Contract = new ethers.Contract("0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D", swapABI, provider);

      // const amountOut = await uniswapV2Contract.getAmountOut(
      //   ethers.utils.parseEther("1"),
      //   reserveIn,
      //   reserveOut
      // );
      // const tokenPriceInETH = ethers.utils.formatEther(amountOut.toString());

      // Get the current price of ETH in USD
      // const ethPriceInUSDResponse = await axios.get("https://api.coingecko.com/api/v3/simple/price?ids=ethereum&vs_currencies=usd");
      // const ethPriceInUSD = ethPriceInUSDResponse.data.ethereum.usd * parseFloat(tokenPriceInETH);

      return {
        priceETH: 0, //parseFloat(tokenPriceInETH).toFixed(8),
        priceUSD: 0,//ethPriceInUSD.toFixed(2),
        supply: Number(ethers.utils.formatEther(supply._hex.toString())),
        minted: Number(ethers.utils.formatEther(minted._hex.toString())),
        endTime: Number(endTime._hex.toString())
      }
    } catch (ex) {
      console.log(ex)
    }
  }

  const getStaked = async (nftIDs: any) => {
    const yieldContract = new ethers.Contract(
      config.YieldAddress,
      config.YieldAbi,
      signer !== null ? signer : provider
    );
    try {
      const staked = await yieldContract.getStaked(nftIDs);
      return staked.map((s: any) => ({
        beeId: Number(s.beeId._hex),
        amounts: s.amounts,
        generations: s.generations
      }))
    } catch (ex) {
      console.log(ex)
    }
  }
  const getMonsterBalance = async () => {
    const tokenContract = new ethers.Contract(
      config.TokenAddress,
      config.MTokenAbi,
      signer !== null ? signer : provider
    );
    try {
      const balance = await tokenContract.balanceOf(account.account.address);
      return balance.toString();
    } catch (ex) {
      console.log(ex)
    }
  }

  React.useEffect(() => {
    // Check if wallet is aleady connected
    // set web3 provider from infura
    let web3 = new Web3.providers.HttpProvider(
      // 'https://mainnet.infura.io/v3/6d07c9b168114102921f5ab6808ef17f'
      // 'http://127.0.0.1:8545'
      RPC_URLS[SupportedChainId.MAINNET]
    );

    injected.isAuthorized().then((isAuthorized) => {
      if (
        isAuthorized &&
        JSON.parse(localStorage.getItem('connected') as string)
      ) {
        injected
          .activate()
          .then((a) => {
            _setAccount({
              address: a.account ? a.account : '',
              provider: a.provider ? a.provider : web3,
            });
            if (a.account !== "") {

              getNFTS(a.account);
              listenStaked(a.account);
              configure(a.provider);
            }
          })
          .catch((e) => {
            // TODO: Handle the error
            console.info(e);
          });
      } else {
        dispatch(setNFTS({ nfts: [] }))
        _setAccount({
          address: '',
          provider: web3,
        });

      }
    });
  }, [_setAccount]);

  React.useEffect(() => {
    if (window.ethereum) {
      window.ethereum.on('chainChanged', () => {
        window.location.reload();
      })
      window?.ethereum.on('accountsChanged', () => {
        window.location.reload();
      })
    }
  })
  React.useEffect(() => {
    init()
  }, [account])

  return (
    <>
      <Home nameToken={nameToken} />
      <Alert />
      <Toast />
    </>
  );
};

export default App;
